import React, { useEffect, useState } from 'react'
//antd
import { notification, Select,Image,Row, Col, Form, Input, Button, Checkbox,Popconfirm, Space, Pagination  } from 'antd'
import Search from 'antd/es/transfer/search'
//support 
import moment from 'moment'
//service
import { deleteMedia, pagingMedia } from '../../../../../services/fileService'
import { ImageDefault } from '../../../../../config/const'
import {  PlayCircleOutlined, ReloadOutlined } from '@ant-design/icons'
import { Player } from "video-react";


function DisplayMedia({onCancel,setValue,setModalVisible,selectedMedia,isShowButton}) {
//state
const [paramsFilter, setParamsFilter] = useState({ amount: 20, page: 1,type:'image'})
const [imgSrc, setImgSrc] = useState([])
const [item,setItem] = useState([])
const [datas,setDatas]= useState([])
const [total,setTotal]= useState(0)
const [checkedItems, setCheckedItems] = useState([]);
const [lastCheckedItemId, setLastCheckedItemId] = useState(null);

//action
const onClick = (event,data) =>{
  const { shiftKey, ctrlKey } = event;
  setImgSrc(`${process.env.REACT_APP_API_ENDPOINT_DEV + data.url}`)
  setItem(data)
  const index = checkedItems.indexOf(data.id);
  if (index === -1) {
    if(shiftKey || ctrlKey){
      setCheckedItems([...checkedItems, data.id]);
    }else{
      setCheckedItems([data.id]);
    }  
    setLastCheckedItemId(data.id);
  }else {
    setCheckedItems(checkedItems.filter((itemId) => itemId !== data.id));
    setLastCheckedItemId([]);
  }

}

const onSubmit = () => {
   const checkedItemsValues = datas.filter((item) => checkedItems.includes(item.id));
   setCheckedItems([])
   setLastCheckedItemId([]);
   if(checkedItemsValues.length < 1){
      return notification.warning({ message: 'Vui lòng chọn media' })
   }
  setValue(checkedItemsValues)
  setModalVisible(false)
};
// search
let timeOut = 500;
const searchPaging = async (search = false) => {
  clearTimeout(timeOut)
  timeOut = setTimeout(() => {
    paging(search.target.value)
  }, timeOut)
}

const changeType = (value) =>{
  paramsFilter.type = value;
  paramsFilter.page = 1;
  paramsFilter.search = "";
  setParamsFilter(paramsFilter)
  paging()
}

const resetPage = () =>{
  paramsFilter.page = 1;
  paramsFilter.search = "";
  setParamsFilter(paramsFilter)
  paging()
}

//service
const paging = async(filter = false)=> {
    paramsFilter.search = filter ? filter : ""
    setParamsFilter(paramsFilter)
    const res = await pagingMedia(paramsFilter)
    if(!res.data || !res.data.code === 200){
        return notification.warning({ message: res.data.message })
    }
    setDatas(res.data.data.list)
    setTotal(res.data.data.total)
}

const _delete = async(id) =>{
  try{
    if(!id){
      return notification.warning({
        message:'Không có ảnh để xóa'
      })
    }else {
      const res = await deleteMedia({id})
      if (!res.data || res.data.code !== 200) {
        return notification.warning({
          message: res.data.message,
        })
      }
    notification.success({ message: res.data.message })
    paging()
    setItem([])
    setImgSrc([])
    }
  }
  catch (err){
     console.log(err)
  }
}

//effect
useEffect(() => {
    paging()
}, [paramsFilter])

  return (
   <>
    <p className='font-semibold text-xl mb-2'>Lọc media</p>
        <div className='flex flex-col gap-4 md:flex-row justify-between'>
            <div className='flex gap-4'>
                <Select defaultValue="image" className='w-36 mr-4' placeholder="Chọn loại" onChange={(value)=>changeType(value)}>
                    <Select.Option value="image">Ảnh</Select.Option>
                    <Select.Option value="video">Video</Select.Option>
                    <Select.Option value="file">File</Select.Option>
                </Select>
                <Button onClick={()=> resetPage()}>
                  <ReloadOutlined />
                </Button>
                <Space>
                  <Pagination simple current={paramsFilter.page}  pageSize={paramsFilter.amount} total={total} onChange={(page, pageSize) => {
                        setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize })
                    }}/>
                </Space>
            </div>
            <div>
                <Search
                    placeholder="Tìm kiếm..."
                    allowClear
                    onChange={searchPaging}
                    style={{ width: 200 }}
                />
            </div>
        </div>
    <Row className='mt-2'>
      <Col span={19} className='max-h-[60vh] overflow-hidden overflow-y-scroll'>
        <div className=' flex flex-wrap gap-[10px]'>
          {datas.map((data) => (
            <div key={data.id} onClick={(event) =>onClick(event,data)} className='relative mr-2 mt-4' style={{display:'inline-flex'}}>
              <div  className='absolute z-10 -right-1 -top-2'    >        
                <Checkbox  className={`${checkedItems.includes(data.id) ? 'active2' :'hidden'} checkMedia ${lastCheckedItemId === data.id? 'active' :''}`}   checked={checkedItems.includes(data.id)}  >
                </Checkbox>
              </div>
              {
                data.type == "image" ? <img 
                className={`cursor-pointer rounded-md border ${lastCheckedItemId === data.id ? 'border-[#2977ff] border-2' : ''}  ${checkedItems.includes(data.id)   ? ' border-2 ': '' }  #2977ff`}
                style={{objectFit:'cover', width:'120px',height:'120px'}}  
                src={data.url ? (['png', 'jpeg', 'jpg','JPG','PNG','JPEG'].includes(data.fileName.slice(
                  ((data.fileName.lastIndexOf('.') - 1) >>> 0) + 2
                )) ? process.env.REACT_APP_API_ENDPOINT_DEV + '/tmp/thumnail/300x300-'+data.fileName : process.env.REACT_APP_API_ENDPOINT_DEV + data.url)  : ImageDefault}
                alt='AVP'
                /> : <div className='flex justify-center h-full' style={{width:'120px',height:'120px',border:'1px solid #e5e7eb',borderRadius:'5px',alignItems:'center'}}  > <PlayCircleOutlined style={{fontSize: '50px'}}/></div>
              }
            </div>
          ))}
        </div>
      </Col>
      <Col span={5} className="px-3">
         <p className='text-base text-neutral-400 italic mb-2 mt-1 '>Chi tiết đính kèm</p>
        {
          item.type == 'image' ? <Image alt='AVP' 
          id="image"
          height ={200}
          src={imgSrc && imgSrc.length > 0 ? imgSrc : ImageDefault}
         ></Image> : <Player
          playsInline
          poster='data:image/png;base64,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'
          src={imgSrc && imgSrc.length > 0 ? imgSrc :  'error'}
          autoPlay={false}
        />
        }
          <p className='font-bold'>{!item.fileName ? 'Name': item.fileName}</p>
          <p className='text-neutral-400'>{!item ? "YYYY/MM/DD" : moment(item.createdAt).format('YYYY-MM-DD hh:mm')}</p> 
          <Popconfirm
              title="Bạn muốn xóa ảnh này không?"
              okText="Có"
              disabled={ !item.id ? true :false}
              cancelText="Không"
              onConfirm={() => _delete(item.id)}
            >
              <Button danger disabled={ !item.id ? true :false} size='small' className='mt-2'>Xóa</Button>
          </Popconfirm>    
         <div className="my-4 mx-2 bg-gray-100 h-[1px]"></div>
         <Form layout='vertical' name='form' 
               fields={[
                {
                  name: ["url"],
                  value: item.url,
                },
                {
                  name: ["title"],
                  value: item.title,
                },
              ]}
         >
            <Form.Item
                    label="Đường dẫn"
                    name="url"    
            >
                    <Input placeholder="Nhập đường dẫn" />
            </Form.Item>
         </Form>
      </Col>
      {
        isShowButton ?<div className='flex gap-2 justify-end mt-2 flex-1'>
        <Button onClick={onCancel} >
            Hủy
        </Button>
        <Button onClick={onSubmit} type="primary" htmlType="submit">
            Thêm
        </Button>
      </div> :''
      }
    </Row>
    <div className='ml-6' style={{fontSize:'16px',fontWeight:'600'}}>Đang hiển thị {datas.length} của {total} file media</div>
   </>
  )
}

export default DisplayMedia
